import { SecuritySettingsView } from '@today/ui-domain'
import { useTranslation } from 'react-i18next'
import { useStartMfaEnrolment } from '@/hooks/useMfaEnrolment'
import { SECURITY_NAMESPACE } from '@/i18n'

/** The Settings "Security" section: starts TOTP enrolment (TO-63 privileged-mfa REQ-013). */
export function SecuritySettings() {
	const { t } = useTranslation(SECURITY_NAMESPACE)
	const enrolment = useStartMfaEnrolment()
	return (
		<SecuritySettingsView
			available={enrolment.available}
			isStarting={enrolment.isStarting}
			onSetUp={enrolment.start}
			labels={{
				title: t('card.title'),
				description: t('card.description'),
				setUp: t('card.setUp'),
				unavailable: t('card.unavailable'),
			}}
		/>
	)
}
